import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Fab from '@material-ui/core/Fab';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Badge from '@material-ui/core/Badge';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import HomeIcon from '@material-ui/icons/Home';
import BookIcon from '@material-ui/icons/Book';
// import DescriptionIcon from '@material-ui/icons/Description';
import ChatIcon from '@material-ui/icons/Chat';
import PersonIcon from '@material-ui/icons/Person';
import MailIcon from '@material-ui/icons/Mail';
import InfoIcon from '@material-ui/icons/Info';
import HelpIcon from '@material-ui/icons/Help';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { useHistory, useLocation } from "react-router-dom";
import serviceRest from '../../../services/serviceRest'

import Tooltip from '@material-ui/core/Tooltip';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import MenuIcon from '@material-ui/icons/Menu';
// import DeleteIcon from '@material-ui/icons/Delete';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
// import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import { useDispatch } from "react-redux";
import { retrieveSessionFrontend } from '../../../actions/sessionFrontend'
import { MySnackbar } from '../../../components/general/mySnackbar/MySnackbar'

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(0) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    avatar: {
        backgroundColor: "#009BA3",
        marginRight: "20px"
    },
    grow: {
        flexGrow: 1,
    },
    listItemSelected: {
        backgroundColor: 'rgba(49,116,141,0.3)!important',
    },
}));

const menuLabel = {
    "FR": [
        "Accueil",
        "Réservations",
        "Panier",
        "Connexion/Inscription",
        "Mes commandes",
        "Messagerie",
        "Mon profil",
        "Contact",
        "FAQ",
        "A propos du site",
        "Déconnexion",
    ],
    "EN": [
        "Home",
        "Bookings",
        "Basket",
        "Connection/Registration",
        "Mes commandes",
        "Messagerie",
        "Mon profil",
        "Contact",
        "FAQ",
        "About this website",
        "Logout",
    ],
}

export default function MenuFrontend({ institution, frontendColor, refresh, language, setLanguage}) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation()
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [sessionChecked, setSessionChecked] = useState(false);
    const [userSession, setUserSession] = useState({});
    const [snack, setSnack] = useState({});
    const [nbUnreadMsg, setNbUnreadMsg] = useState(0);
    const [nbOrderWaiting, setNbOrderWaiting] = useState(0);
    const [nbCartResources, setNbCartResources] = useState(0);
    const [cartOpen, setCartOpen] = useState(false);
    const [cartContent, setCartContent] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);

    useEffect(() => {
        let promise = dispatch(retrieveSessionFrontend());
        promise.then((response) => {
            if (response.data.infos.redirectProfil) {
                history.push("/frontend/profil/" + institution)
            }
            setUserSession(response.data.infos)
            setSessionChecked(true);
        });
        
        if (institution!=="") {
            let param = { "institution": institution };
            serviceRest.post('/react/frontendController/getCart', param).then((response) => {
                setNbCartResources(response.data.cartContent.length)
                setCartContent(response.data.cartContent)
            }, (error) => {
                console.log(error);
            });
        }
    }, [history, dispatch, history.location.pathname, refresh, institution]);

    useEffect(() => {
        if (userSession.connected) {
            let param = {};
            serviceRest.post('/react/frontendController/unreadMsg', param).then((response) => {
                setNbUnreadMsg(response.data.nbUnread)
                setNbOrderWaiting(response.data.nbOrderWaiting)
            }, (error) => {
                console.log(error);
            });
        }
    }, [sessionChecked, refresh, userSession.connected]);

    const handleLogout = () => {
        let param = {};
        serviceRest.post('/react/user/frontendLogout', param).then((response) => {
            if (response.data.error) {
                setSnack({ message: response.data.message, show: true, severity: "error" })
            } else {
                setUserSession({})
                history.push('/frontend/home/' + institution);
            }
        }, (error) => {
            console.log(error);
        });
    }

    const handleCart = () => {
        setCartOpen(true)
    }

    const handleNavigate = (hrefLocation, type) => {
        if (type==="location") {
            window.location.href = hrefLocation
        } else {
            history.push(hrefLocation)
        }
        setOpen(false);
    }
    
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleCartDrawerClose = (event) => {
        setCartOpen(false);
    };
    const Cart = () => (
        <Drawer anchor="right" open={cartOpen} onClose={handleCartDrawerClose}>
            <div
                role="presentation"
                onClick={handleCartDrawerClose}
                onKeyDown={handleCartDrawerClose}
                style={{maxWidth:"30vh", padding:"10px"}}
            >
                <Typography variant="h5" gutterBottom style={{padding:"10px"}}>
                    {cartContent.length} réservations
                </Typography>
                <Divider />
                <List>
                    {cartContent.map((item, index) => (
                        <ListItem button key={item.cartID} onClick={_ => handleNavigate("/frontend/cart/" + institution)}>
                            <ListItemText primary={<div dangerouslySetInnerHTML={{ __html: item.Description }} />} />
                            {/* <ListItemSecondaryAction>
                                <IconButton edge="end" aria-label="delete" onClick={_ => deleteFromCart(item.cartID)}>
                                    <Tooltip
                                        title={<h3>Supprimer la ressource du panier</h3>}
                                        aria-label='Supprimer la ressource du panier'
                                    >
                                        <DeleteIcon style={{ color: "red" }} />
                                    </Tooltip>
                                </IconButton>
                            </ListItemSecondaryAction> */}
                        </ListItem>
                    ))}
                </List>
                <Divider />
                <Button style={{marginTop:"10px"}} size="small" variant="contained" color="primary" fullWidth onClick={_ => handleNavigate("/frontend/cart/" + institution)} >Voir mon panier</Button>
            </div>
        </Drawer>
    );

    const handleClickLanguageMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseLanguageMenu = () => {
        setAnchorEl(null);
    };

    const handleCloseLanguageMenuSelection = (lang) => {
        setLanguage(lang)
        setAnchorEl(null);
    }

    const MenuList = ({language}) => {
        return <List>
            <ListItem
                classes={{ selected: classes.listItemSelected }}
                button
                onClick={_ => handleNavigate("/frontend/home/" + institution)}
                selected={location.pathname === "/frontend/home/" + institution}
            >
                <Tooltip
                    title={<h3>{menuLabel[language][0]}</h3>}
                    aria-label={menuLabel[language][0]}
                    placement="right"
                >
                    <ListItemIcon><HomeIcon /></ListItemIcon>
                </Tooltip>
                <ListItemText primary={menuLabel[language][0]} />
            </ListItem>
            <ListItem
                classes={{ selected: classes.listItemSelected }}
                button
                onClick={_ => handleNavigate("/frontend/reservations/" + institution)}
                selected={location.pathname === "/frontend/reservations/" + institution}
            >
                <Tooltip
                    title={<h3>{menuLabel[language][1]}</h3>}
                    aria-label={menuLabel[language][1]}
                    placement="right"
                >
                    <ListItemIcon><BookIcon /></ListItemIcon>
                </Tooltip>
                <ListItemText primary={menuLabel[language][1]} />
            </ListItem>
            <ListItem
                classes={{ selected: classes.listItemSelected }}
                button
                onClick={_ => handleNavigate("/frontend/cart/" + institution)}
                selected={location.pathname === "/frontend/cart/" + institution}
            >
                <Tooltip
                    title={<h3>{menuLabel[language][2]}</h3>}
                    aria-label={menuLabel[language][2]}
                    placement="right"
                >
                    <ListItemIcon><Badge badgeContent={nbCartResources} color="primary"><ShoppingCartIcon /></Badge></ListItemIcon>
                </Tooltip>
                <ListItemText primary={menuLabel[language][2]} />
            </ListItem>
            {!userSession.connected &&
                <ListItem
                    classes={{ selected: classes.listItemSelected }}
                    button
                    onClick={_ => handleNavigate("/frontend/connexion/" + institution)}
                    selected={location.pathname === "/frontend/connexion/" + institution}
                >
                    <Tooltip
                        title={<h3>{menuLabel[language][3]}</h3>}
                        aria-label={menuLabel[language][3]}
                        placement="right"
                    >
                        <ListItemIcon><VpnKeyIcon /></ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={menuLabel[language][3]}/>
                </ListItem>}
            {userSession.connected && <>
                <ListItem
                    classes={{ selected: classes.listItemSelected }}
                    button
                    onClick={_ => handleNavigate("/frontend/orders/" + institution)}
                    selected={location.pathname === "/frontend/orders/" + institution}
                >
                    <Tooltip
                        title={<h3>{menuLabel[language][4]}</h3>}
                        aria-label={menuLabel[language][4]}
                        placement="right"
                    >
                        <ListItemIcon><Badge badgeContent={nbOrderWaiting} color="primary"><InboxIcon /></Badge></ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={menuLabel[language][4]} />
                </ListItem>
                <ListItem
                    classes={{ selected: classes.listItemSelected }}
                    button
                    onClick={_ => handleNavigate("/frontend/messages/" + institution)}
                    selected={location.pathname === "/frontend/messages/" + institution}
                >
                    <Tooltip
                        title={<h3>{menuLabel[language][5]}</h3>}
                        aria-label={menuLabel[language][5]}
                        placement="right"
                    >
                        <ListItemIcon><Badge badgeContent={nbUnreadMsg} color="primary"><ChatIcon /></Badge></ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={menuLabel[language][5]} />
                </ListItem>
                <ListItem
                    classes={{ selected: classes.listItemSelected }}
                    button
                    onClick={_ => handleNavigate("/frontend/profil/" + institution)}
                    selected={location.pathname === "/frontend/profil/" + institution}
                >
                    <Tooltip
                        title={<h3>{menuLabel[language][6]}</h3>}
                        aria-label={menuLabel[language][6]}
                        placement="right"
                    >
                        <ListItemIcon><PersonIcon /></ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={menuLabel[language][6]} />
                </ListItem>
            </>}
            <ListItem
                classes={{ selected: classes.listItemSelected }}
                button
                onClick={_ => handleNavigate("/frontend/contact/" + institution)}
                selected={location.pathname === "/frontend/contact/" + institution}
            >
                <Tooltip
                    title={<h3>{menuLabel[language][7]}</h3>}
                    aria-label={menuLabel[language][7]}
                    placement="right"
                >
                    <ListItemIcon><MailIcon /></ListItemIcon>
                </Tooltip>
                <ListItemText primary={menuLabel[language][7]} />
            </ListItem>
            <ListItem
                classes={{ selected: classes.listItemSelected }}
                button
                onClick={_ => handleNavigate("/frontend/faq/" + institution)}
                selected={location.pathname === "/frontend/faq/" + institution}
            >
                <Tooltip
                    title={<h3>{menuLabel[language][8]}</h3>}
                    aria-label={menuLabel[language][8]}
                    placement="right"
                >
                    <ListItemIcon><InfoIcon /></ListItemIcon>
                </Tooltip>
                <ListItemText primary={menuLabel[language][8]} />
            </ListItem>
            <ListItem
                classes={{ selected: classes.listItemSelected }}
                button
                onClick={_ => handleNavigate("/frontend/about/" + institution)}
                selected={location.pathname === "/frontend/about/" + institution}
            >
                <Tooltip
                    title={<h3>{menuLabel[language][9]}</h3>}
                    aria-label={menuLabel[language][9]}
                    placement="right"
                >
                    <ListItemIcon><HelpIcon /></ListItemIcon>
                </Tooltip>
                <ListItemText primary={menuLabel[language][9]} />
            </ListItem>
            {userSession.connected &&
                <ListItem button onClick={handleLogout}>
                    <Tooltip
                        title={<h3>{menuLabel[language][10]}</h3>}
                        aria-label={menuLabel[language][10]}
                        placement="right"
                    >
                        <ListItemIcon><ExitToAppIcon /></ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={menuLabel[language][10]} />
                </ListItem>}
        </List>
    }

    const MenuListUNIGE = ({ language }) => {
        return <List>
            <ListItem
                classes={{ selected: classes.listItemSelected }}
                button
                onClick={_ => handleNavigate("/frontend/home/" + institution)}
                selected={location.pathname === "/frontend/home/" + institution}
            >
                <Tooltip
                    title={<h3>{menuLabel[language][0]}</h3>}
                    aria-label={menuLabel[language][0]}
                    placement="right"
                >
                    <ListItemIcon><HomeIcon /></ListItemIcon>
                </Tooltip>
                <ListItemText primary={menuLabel[language][0]} />
            </ListItem>
            <ListItem
                classes={{ selected: classes.listItemSelected }}
                button
                onClick={_ => handleNavigate("/protected/dispo/" + institution,"location")}
                selected={location.pathname === "/protected/dispo/" + institution}
            >
                <Tooltip
                    title={<h3>Disponibilités des salles</h3>}
                    aria-label="Disponibilités des salles"
                    placement="right"
                >
                    <ListItemIcon><BookIcon /></ListItemIcon>
                </Tooltip>
                <ListItemText primary="Disponibilités des salles" />
            </ListItem>
        </List>
    }

    return (
        (sessionChecked && !location.pathname.toLowerCase().includes("/frontend/planningalone/") && !location.pathname.toLowerCase().includes("/frontend/light/planning/") && !location.pathname.toLowerCase().includes("/frontend/planninggroup/")) &&
        <div className={classes.root}>
                <MySnackbar params={snack} />
                <CssBaseline />
                <AppBar
                    style={{ background: frontendColor}}
                    position="fixed"
                    className={clsx(classes.appBar, {
                        [classes.appBarShift]: open,
                    })}
                >
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            className={clsx(classes.menuButton, {
                                [classes.hide]: open,
                            })}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" noWrap>
                            {(institution === "DCTI" | institution=== "UNIGE") ? "Mobilys" : institution }
                        </Typography>
                        <div className={classes.grow} />
                        {userSession.customerData==="DCTI" && <><Fab
                            aria-controls="language-menu"
                            aria-haspopup="true"
                            variant="contained"
                            color="primary"
                            onClick={handleClickLanguageMenu}
                            className={classes.menuButton}
                            size="medium"
                        >
                            {language}
                        </Fab>
                            <Menu
                                id="language-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleCloseLanguageMenu}
                            >
                                <MenuItem onClick={_=>handleCloseLanguageMenuSelection("FR")}>FR</MenuItem>
                                <MenuItem onClick={_=>handleCloseLanguageMenuSelection("EN")}>EN</MenuItem>
                            </Menu>
                        </>}
                        <IconButton edge="start" className={classes.menuButton} onClick={handleCart} color="inherit" aria-label="logout">
                            <Tooltip
                                title={<h3>Panier</h3>}
                                aria-label='Panier'
                            >
                                <Badge badgeContent={nbCartResources} color="primary"><ShoppingCartIcon /></Badge>
                            </Tooltip>
                        </IconButton>
                        {userSession.connected &&
                            <Tooltip
                                title={<h3>{userSession.userAccount.compte_utilisateur_client[0].CLI_PRENOM + " " + userSession.userAccount.compte_utilisateur_client[0].CLI_NOM}</h3>}
                                aria-label={userSession.userAccount.compte_utilisateur_client[0].CLI_PRENOM + " " + userSession.userAccount.compte_utilisateur_client[0].CLI_NOM}
                            >
                                <Chip
                                    color="primary"
                                    style={{ background: frontendColor, maxWidth: "200px"}}
                                    avatar={<Avatar>{userSession.userAccount.compte_utilisateur_client[0].CLI_PRENOM.substring(0, 1) + userSession.userAccount.compte_utilisateur_client[0].CLI_NOM.substring(0, 1)}</Avatar>}
                                />
                            </Tooltip>
                        }
                    </Toolbar>
                </AppBar>
                <Drawer
                    // PaperProps={{ style: { height: "96vh" } }}
                    variant="permanent"
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    })}
                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open,
                        }),
                    }}
                >
                    <div className={classes.toolbar}>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                        </IconButton>
                    </div>
                    <Divider />
                    {institution==="UNIGE" ?
                        <MenuListUNIGE language={language} />
                    :
                        <MenuList language={language} />
                    }
                </Drawer>
                <Cart />
            </div>
    );
}